import { zergApi } from "@/service/zerg";

class EmailRecipientGroupsService {
    BASE_URL = "setting/general/recipients-group";

    async createOrUpdateRecipientGroup(params) {
        const url = `${this.BASE_URL}/create-or-update-recipient-group`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async enableOrDisableRecipientGroup(params) {
        const url = `${this.BASE_URL}/enable-or-disable-recipient-group`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async listRecipientsGroups(params) {
        const url = `${this.BASE_URL}/list-recipients-groups`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async searchUsersByText(params) {
        const url = `${this.BASE_URL}/search-users-by-text`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async addUserIntoRecipientGroup(params) {
        const url = `${this.BASE_URL}/add-user-into-recipient-group`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async removeUserFromRecipientGroup(params) {
        const url = `${this.BASE_URL}/remove-user-from-recipient-group`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

}

export default new EmailRecipientGroupsService();